import React from "react";
import CustomText, {CustomTextProps} from "../index";

const HeaderOneMobile = (props: CustomTextProps) => {
    return (
        <CustomText size={20} height={23} weight={700} {...props}>
            {props.children}
        </CustomText>
    )
}

export default HeaderOneMobile;